var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    [
      _vm.editView ? _c("StandaloneWpEdit") : _vm._e(),
      _vm._v(" "),
      !_vm.editView
        ? _c(
            "div",
            { staticClass: "standalone-wp-view-container" },
            [
              _c(
                "Sticky",
                {
                  staticClass: "stick-btnGroup",
                  attrs: {
                    extendStickyClass: "stickyBtnClass",
                    fullWidth: true,
                    align: _vm.batch ? "right" : "left",
                  },
                },
                [
                  _c(
                    "div",
                    { staticClass: "back-button" },
                    [
                      _vm.navEntries.length
                        ? _c("HKLHeader", {
                            attrs: {
                              labelLeftPrimary: _vm.$t(
                                "listNavigation.backToDashboard"
                              ),
                              labelRightLeading: _vm.$t(
                                "listNavigation.previousRecord"
                              ),
                              labelRightTrailing: _vm.$t(
                                "listNavigation.nextRecord"
                              ),
                              navigationEntries: _vm.navEntries,
                              currentRecordId: _vm.currentRecordId,
                              navigatePrevEnabled: _vm.batch
                                ? _vm.canPrev
                                : undefined,
                              navigateNextEnabled: _vm.batch
                                ? _vm.canNext
                                : undefined,
                            },
                            on: {
                              "left-primary": _vm.navToWorkPermitDashboard,
                              "right-leading": _vm.prev,
                              "right-trailing": _vm.next,
                            },
                          })
                        : !_vm.batch
                        ? _c(
                            "span",
                            {
                              staticClass: "back",
                              on: {
                                click: function ($event) {
                                  return _vm.back()
                                },
                              },
                            },
                            [
                              _vm._v(
                                "\n          < " +
                                  _vm._s(_vm.$t("back")) +
                                  "\n        "
                              ),
                            ]
                          )
                        : _vm._e(),
                    ],
                    1
                  ),
                ]
              ),
              _vm._v(" "),
              _c("WorkPermitDetail", {
                attrs: {
                  isProjectAvailable: true,
                  focusPermitId: _vm.focusPermitId,
                  isPPSuspened: _vm.isPPSuspened,
                },
              }),
            ],
            1
          )
        : _vm._e(),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }